import React from 'react'
import { Form, InputNumber, Tooltip } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { IconFont } from '@/components'

const ExecutionPriorityInput: React.FC = () => (
  <Wrapper>
    <Form.Item label={t('执行速率')} name="reduceSpeed">
      <InputNumber min={1} max={40} addonAfter={t('个/秒')} style={{ width: 360 }} />
    </Form.Item>
    <Form.Item
      name="priority"
      label={
        <div className="custom-label">
          <span>{t('优先级')}</span>
        </div>
      }
    >
      <InputNumber
        min={1}
        max={5}
        style={{ width: 360 }}
        precision={0}
        parser={value => {
          if (value === undefined || value === '') return ''
          const parsed = parseInt(value)
          return isNaN(parsed) ? '' : parsed
        }}
        addonAfter={
          <Tooltip title={t('数字越大，优先级越高')}>
            <IconFont type="icon-icon_help" className="help-icon" />
          </Tooltip>
        }
      />
    </Form.Item>
  </Wrapper>
)

export default ExecutionPriorityInput

const Wrapper = styled.div`
  margin-left: 45px;

  .custom-label {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .help-icon {
    color: #999;
    font-size: 16px;
    cursor: 'pointer';
  }
`
